/**
 * A PARANCSPALETTA MAGJA — mit tud, és hogyan szűkül. React nélkül.
 *
 * A D9 kiegészítése (2026-08-28) szerint a paletta „az a hely, ahova a RITKA
 * MŰVELETEK mennek, és egyben a »művelet, nem oldal« szabály végrehajtó
 * eszköze". Ez a második fele a fontosabb: a `CLAUDE.md` §2 szerint negyedik
 * felület nincs, és a szinkronizálás, az értesítés, az export MŰVELET, nem
 * oldal. Ha nincs hova tenni őket, előbb-utóbb képernyőt kapnak — a paletta
 * az a hova.
 *
 * ⚠️ AMI MA NINCS BENNE, ÉS MIÉRT. A D9 az ügyfélváltást és az időszakot is
 * ide sorolja. Az ügyfélváltás bekerült (#73): a felület a választást küldi,
 * a szerver a hatókörrel metszi (`company-selection.ts`). Az időszakhoz
 * viszont nincs szűrő egyik listán sem — helyőrzőként felvéve olyan
 * műveletet ígérne, ami nem történik meg.
 */

import { matchesQuery } from '@/utils/fold';

/**
 * EGY PARANCS. A `labelKey` i18n-kulcs, nem szöveg — a szűrés viszont a
 * FORDÍTOTT szövegen megy, mert a könyvelő azt látja és arra gépel.
 */
export interface Command {
  id: string;
  labelKey: string;
  /** A billentyű, ha van rá közvetlen is — a paletta kiírja. */
  hint?: string;
  run: () => void;
}

/**
 * A SZŰRÉS ÉKEZET- ÉS KISBETŰ-ÉRZÉKETLEN, és SZAVANKÉNT szűkít — a „bill súgó"
 * megtalálja a „Billentyű-súgó"-t, pedig összefüggő részláncként nem szerepel
 * benne. Aki palettát használ, töredékeket gépel.
 *
 * A hajtogatás a `@/utils/fold`-ban lakik, mert a listák keresése (`/`)
 * ugyanazt a szabályt követi — két külön változat pont abban csúszna el, ami
 * miatt van.
 */
export function filterCommands(
  commands: Command[],
  query: string,
  label: (command: Command) => string
): Command[] {
  return commands.filter((command) => matchesQuery(label(command), query));
}

/**
 * A KIJELÖLÉS A SZŰKÍTÉS UTÁN IS ÉRVÉNYES MARAD.
 *
 * Ha a kijelölt parancs kiesett a találatokból, az ELSŐRE lépünk — nem a
 * semmire. Egy üres kijelölés mellett az `Enter` nem csinálna semmit, és a
 * könyvelő azt hinné, a paletta elromlott.
 */
export function keepSelection(matches: Command[], selectedId: string | null): string | null {
  if (matches.length === 0) {
    return null;
  }
  if (selectedId !== null && matches.some((command) => command.id === selectedId)) {
    return selectedId;
  }
  return matches[0].id;
}

/** A lista VÉGÉN KÖRBEFORDUL — rövid listán ez a gyorsabb, nem a megállás. */
export function step(matches: Command[], selectedId: string | null, delta: number): string | null {
  if (matches.length === 0) {
    return null;
  }

  const at = matches.findIndex((command) => command.id === selectedId);
  if (at === -1) {
    return matches[0].id;
  }

  const next = (at + delta + matches.length) % matches.length;
  return matches[next].id;
}
